import type { RouteLocationNormalized } from 'vue-router';

import {
	captureCampaignFromRoute,
	refreshCampaignActivity,
	syncCampaignToSessionStorage
} from '~/composables/adCampaign/utils';
import {
	refreshSessionActivity,
	syncSessionToSessionStorage
} from '~/composables/visitorIdentity/utils';

/**
 * Client-side plugin that runs once during hydration to:
 * 1. Sync campaign + session data from the localStorage bridge into
 *    sessionStorage (covers new tabs opened via target="_blank")
 * 2. Capture UTM params from the landing URL (fills the SSR hydration gap)
 * 3. Refresh the bridge timestamps (inactivity heartbeat)
 */
export default defineNuxtPlugin(() => {
	const route = useRoute();

	syncCampaignToSessionStorage();
	syncSessionToSessionStorage();
	captureCampaignFromRoute(route as unknown as RouteLocationNormalized);
	refreshCampaignActivity();
	refreshSessionActivity();
});
